import { Pipe, PipeTransform } from '@angular/core';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'plurarText',
  standalone: true
})
export class PlurarTextPipe implements PipeTransform {

  transform(text: string, length: number, suffix: string = 's'): string {
    return length > 1 ? text + suffix : text;
  }

}
